import axios from "axios";

const UPDATE_PASSWORD = "/user/update-password";
export const updatePasswordApi = info => {
  return axios.put(UPDATE_PASSWORD, info).then(({ data }) => data);
};
